__turbopack_context__.v({
  "passport_transfer_page": "PassportTransferPage-module-scss-module__KQxbdq__passport_transfer_page",
  "passport_transfer_page__error_message": "PassportTransferPage-module-scss-module__KQxbdq__passport_transfer_page__error_message",
  "passport_transfer_page__loading": "PassportTransferPage-module-scss-module__KQxbdq__passport_transfer_page__loading",
});
